import { Routes } from '@angular/router';
import { WorldCruisesType01Component } from './world-cruises/world-cruises-type01.component';
export default [
    {
        path     : '',
        component: WorldCruisesType01Component,
    },
    
] as Routes;
